// extracted by mini-css-extract-plugin
export default {"item":"Nav_item__dafOT","title":"Nav_title__StduC","wrap":"Nav_wrap__9aUpW"};